import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { AggregatedUserOverviewMeasurement } from "@msuite/utils/types";

export function RowActions({ cell }: CellContext<AggregatedUserOverviewMeasurement, "actions">) {
	/** Hooks */
	return <RowActionsWrapper to={`/controlling/measurements/${cell.row.original.member.user.id}`} />;
}
